import ENV from "config/Env";
import { ApiInstance } from "utils/Api";

const getChecklistReportUrl = async (car_check_id: number) => {
  return ApiInstance.post("/pdfs/url", { car_check_id });
};

const getChecklistReport = async (car_check_id: number) => {
  return ApiInstance.post(`/pdfs/download`, { car_check_id }, ENV.appointmentBaseURL, { responseType: "blob" });
};

export { getChecklistReport, getChecklistReportUrl };
